import React from 'react'
import VideoThumb from '../video/VideoThumb'
import { browserHistory } from 'react-router'
import { find } from 'lodash';

const AreaPageContent = (props) => {
	const { area, videos, videoClick} = props;
	// console.log(videos)
		return (
      <main className="main " >
				<div className="page mt3 mb8">
					<br />
					<a className="link" onClick={browserHistory.goBack}>Back</a>
					<h5>{area.name}</h5>
						<div>
						 {area.description? <div className="card-content">{area.description
							.split('\n')
							.map((t, i) => <p key={`${area._id}-${i}`}>{t}</p>)}</div>
							: null
							}

							<div className="video-grid grid">
								{area.videos.map(videoId => videos.filter(vid => {
									return vid['id'] == videoId
								}).length > 0 && 
									<VideoThumb 
									showDescription={false} 
									click={videoClick} 
									class="thumb" 
									key={`video-${videoId}`}  
									video={ _.find(videos, ['_id', videoId]) } />
									)}
							</div>
						</div>
				</div>
			</main>)
}

export default AreaPageContent;



// WEBPACK FOOTER //
// ./src/components/home/AreaPageContent.jsx